
import React, { useEffect, useState, useRef } from "react";
import {
    ArrowLeftOutlined, CalendarOutlined, DownloadOutlined
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { BsInfoCircleFill } from "react-icons/bs"
import { BiPoll } from "react-icons/bi"
import { FiGlobe } from "react-icons/fi"
import { useSelector } from "react-redux";
import { Breadcrumb, Button, Checkbox, Select, Tooltip, message, notification } from "antd";
import InsightsServices from "../../../../services/Insights.services";
import { generateTints } from "../../../../utils/Color.Helper"
import { setGenerateGridData, setGenerateWhitespaceReport, setReportIsLoading } from "../../../../store/components/Reports.slice";
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import Container from "../../../General/Container/Container";
import TreeMapSkeleton from "../../../General/skeleton/TreeMapSkeleton";
import WhiteSpaceNewDisplayLegend from "./WhiteSpaceNewDisplayLegend"
import WhiteSpaceNewDisplayDetails from "./WhiteSpaceNewDisplayDetails"
import TreemapChart from "../../../Charts/TreemapChart"
import { dynamicSort, formatNumber } from "../../../../utils/MainHelper";
import CompetitorMaster from "./Competitor/CompetitorMaster";
import { downloadWhitespaceCompetitor, getBrandGenericsHcp } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import WorkerServices from "../../../../services/Worker.services";

const CheckboxGroup = Checkbox.Group;

function WhiteSpaceNewDisplay() {
    const dispatch = useDispatch()
    const infoRef = useRef()
    const infoRefComp = useRef()
    const mapRef = useRef()
    const mapRefComp = useRef()
    const { generateGrid, reportIsLoading, generateWhitespaceReport } = useSelector((state) => state.reports);
    const [treeMapData, setTreeMapData] = useState([])
    const [chartData, setChartData] = useState([])
    const [infoList, setInfoList] = useState([])
    const [infoListComp, setInfoListComp] = useState([])
    const [competitorCheckedCategories, setCompetitorCheckedCategories] = useState([])
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedItemComp, setSelectedItemComp] = useState(null)
    const [loadingText, setLoadingText] = useState(true)
    const [loadingTextComp, setLoadingTextComp] = useState(false)
    const [text, setText] = useState("")
    const [textComp, setTextComp] = useState("")
    const [isLast, setIsLast] = useState(false)
    const [isLastComp, setIsLastComp] = useState(false)
    const [temporaryMokbMicroList, setTemporaryMokbMicroList] = useState({})
    const [breadItems, setBreadItems] = useState([{
        path: "summary",
        name: "Summary"
    }]);
    const [checkAll, setCheckAll] = useState(false)
    const [breadItemsComp, setBreadItemsComp] = useState([{
        path: "summary",
        name: "Summary"
    }]);
    const [brandList, setBrandList] = useState([])
    const [competitorMaster, setCompetitorMaster] = useState("");
    const [competitorIsError, setCompetitorIsError] = useState(true);
    const [competitorData, setCompetitorData] = useState([])
    const [treeMapDataComp, setTreeMapDataComp] = useState([])
    const [chartDataComp, setChartDataComp] = useState([])
    const [competitorLoading, setCompetitorLoading] = useState(false)
    const [triggerResize, setTriggerResize] = useState(false)
    const { collapseLSide } = useSelector((state) => state.expandstore)

    const onClickTile = (args, data) => {
        const tileData = data || args[0]?.data?.data?.data;
        const runFound = (found) => {
            if (found && (found.children || found.tChildren)) {
                if (found.lvl !== 3) {
                    const [firstChild] = found.children;
                    // if (firstChild.tempChildren || firstChild.children) {
                    setBreadItems((bread) => {
                        const tempObj = [...bread].reduce((acc, item) => {
                            if (!acc.checker[item.name]) {
                                acc.checker[item.name] = true
                                acc.list.push(item)
                            }
                            return acc
                        }, {
                            checker: {},
                            list: []
                        })
                        if (!tempObj.checker[found.name || found.title]) {
                            tempObj.list.push(found)
                        }
                        return tempObj.list
                    })
                    // } else {
                    //     console.log("No more deep dive.")
                    // }
                }
            } else {
                console.log("No more deep dive.")
            }
        }
        setTreeMapData((prev) => {
            return prev.map((item) => {
                if (item.title === tileData.title) {
                    runFound(item)
                }
                return item
            })
        })
    }

    const onClickTileComp = (args, data) => {
        const tileData = data || args[0]?.data?.data?.data;
        const runFound = (found) => {
            if (found && (found.children || found.tChildren)) {
                if (found.lvl !== 3) {
                    const [firstChild] = found.children;
                    // if (firstChild.tempChildren || firstChild.children) {
                    setBreadItemsComp((bread) => {
                        const tempObj = [...bread].reduce((acc, item) => {
                            if (!acc.checker[item.name]) {
                                acc.checker[item.name] = true
                                acc.list.push(item)
                            }
                            return acc
                        }, {
                            checker: {},
                            list: []
                        })
                        if (!tempObj.checker[found.name]) {
                            tempObj.list.push(found)
                        }
                        return tempObj.list
                    })
                    // } else {
                    //     console.log("No more deep dive.")
                    // }
                }
            } else {
                console.log("No more deep dive.")
            }
        }
        setTreeMapDataComp((prev) => {
            return prev.map((item) => {
                if (item.title === tileData.title) {
                    runFound(item)
                }
                return item
            })
        })
    }

    const getBrandspaceSummaryText = (item) => {
        if (!item) return
        setSelectedItem(item)
        setLoadingText(true)
        return InsightsServices.get10Keywords([item]).then(async (resp) => {
            setLoadingText(false)
            setText(resp)
            onload()
        })
    }

    const getBrandspaceSummaryTextComp = (item) => {
        if (!item) return
        setSelectedItemComp(item)
        setLoadingTextComp(true)
        return InsightsServices.getTopWhitespaceBrandspaceText([item]).then(async (resp) => {
            setLoadingTextComp(false)
            if (resp && resp?.data?.[0]) {
                await setTextComp(resp?.data?.[0])
            } else {
                await setTextComp("")
            }
            onloadComp()
        })
    }

    const onload = () => {
        if (mapRef.current && infoRef.current) {
            try {
                const pRect = mapRef.current.getBoundingClientRect().toJSON()
                const { left: pLeft, top: pTop } = pRect
                let tempList = []
                const paths = Array.from(mapRef.current.querySelectorAll("svg g:nth-last-child(1) path"));
                paths.forEach((path, idx) => {
                    const rect = path.getBoundingClientRect().toJSON()
                    const { left, top, width, height } = rect
                    const currentItem = treeMapData[idx]

                    const newDisplaySize = currentItem.segmentSize
                    // const usedSize = currentItem.masterSize
                    const score = currentItem.diff
                    const isSmallMapWidth = width < 168
                    const isSmallMapHeight = height < 59
                    let textFontSize = "13px"
                    let iconFontSize = "13px"
                    if (isSmallMapWidth) {
                        textFontSize = `${width * 0.075}px`
                        iconFontSize = `${width * 0.06}px`
                    }
                    if (isSmallMapHeight) {
                        const multiplier = width < 42 ? 0.055 : 0.155
                        textFontSize = `${height * multiplier}px`
                        iconFontSize = `${height * multiplier}px`
                    }
                    const itemTipStyle = {
                        display: "block",
                        width: "100%",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        overflow: "hidden",
                        fontSize: "13px"
                    }
                    const itemStyle = {
                        display: "block",
                        width: "100%",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        overflow: "hidden",
                        fontSize: textFontSize
                    }
                    const divElem = <Tooltip placement="top" title={
                        <Container className="dcol">
                            <Container className="drow align-center gap-5p"><label style={itemTipStyle}>{currentItem.title || currentItem.name}</label></Container>
                            <Container className="drow align-center gap-1">
                                <Container className="drow align-center gap-5p">
                                    <BiPoll />
                                    <label style={itemTipStyle}>{`${(formatNumber(score, 2))}%`}</label>
                                </Container>
                                {newDisplaySize ? <Container className="drow align-center gap-5p">
                                    <CalendarOutlined />
                                    <label style={itemTipStyle}>{formatNumber(newDisplaySize)}</label>
                                </Container> : ""}
                            </Container>
                        </Container>
                    }><div
                        style={{
                            position: "absolute",
                            left: (left - pLeft),
                            top: (top - pTop),
                            height,
                            width,
                            zIndex: 2,
                            cursor: "pointer",
                            color: "white",
                            overflow: "hidden"
                        }}
                        onClick={() => {
                            onClickTile(undefined, currentItem)
                        }}
                    >
                            <Container className="dcol fullscreen align-center justify-center" style={{ padding: "10px" }}>
                                <Container className="drow align-center gap-5p"><label style={{
                                    ...itemStyle,
                                    textAlign: "center"
                                }}>{currentItem.title || currentItem.name}</label></Container>
                                <Container className="drow align-center gap-1">
                                    <Container className="drow align-center gap-5p">
                                        <BiPoll style={{ fontSize: iconFontSize }} />
                                        <label style={itemStyle}>{`${(formatNumber(score, 2))}%`}</label>
                                    </Container>
                                    {newDisplaySize ? <Container className="drow align-center gap-5p">
                                        <CalendarOutlined style={{ fontSize: iconFontSize }} />
                                        <label style={itemStyle}>{formatNumber(newDisplaySize)}</label>
                                    </Container> : ""}
                                </Container>
                            </Container>
                            {(isLast ? <BsInfoCircleFill
                                onClick={() => { getBrandspaceSummaryText(treeMapData[idx]) }}
                                style={{
                                    position: "absolute",
                                    // left: (left - pLeft) + (width - 20),
                                    // top: (top - pTop) + 5,
                                    right: "2px",
                                    top: "2px",
                                    color: "black",
                                    zIndex: 3,
                                    fill: "rgb(242 238 238)",
                                    fontSize: "15px",
                                    cursor: "pointer"
                                }} /> : null)
                            }
                        </div>
                    </Tooltip>
                    tempList.push(divElem);
                })
                setInfoList(tempList)
            } catch (error) {
                setInfoList([])
            }
        }
    }

    const onloadComp = () => {
        if (mapRefComp.current && infoRefComp.current) {
            try {
                const pRect = mapRefComp.current.getBoundingClientRect().toJSON()
                const { left: pLeft, top: pTop } = pRect
                let tempList = []
                const paths = Array.from(mapRefComp.current.querySelectorAll("svg g:nth-last-child(1) path"));
                paths.forEach((path, idx) => {
                    const rect = path.getBoundingClientRect().toJSON()
                    const { left, top, width, height } = rect
                    const currentItem = treeMapDataComp[idx]
                    // const usedSize = currentItem.masterSize
                    const score = currentItem.diff

                    const newDisplaySize = (currentItem.audienceIntersect || currentItem.segmentSize) * (score / 100)
                    const isSmallMapWidth = width < 168
                    const isSmallMapHeight = height < 59
                    let textFontSize = "13px"
                    let iconFontSize = "13px"
                    if (isSmallMapWidth) {
                        textFontSize = `${width * 0.075}px`
                        iconFontSize = `${width * 0.06}px`
                    }
                    if (isSmallMapHeight) {
                        const multiplier = width < 42 ? 0.055 : 0.155
                        textFontSize = `${height * multiplier}px`
                        iconFontSize = `${height * multiplier}px`
                    }
                    const itemTipStyle = {
                        display: "block",
                        width: "100%",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        overflow: "hidden",
                        fontSize: "13px"
                    }
                    const itemStyle = {
                        display: "block",
                        width: "100%",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        overflow: "hidden",
                        fontSize: textFontSize
                    }
                    const divElem = <Tooltip placement="top" title={<Container className="dcol">
                        <Container className="drow align-center gap-5p"><label style={itemTipStyle}>{currentItem.title || currentItem.name}</label></Container>
                        <Container className="drow align-center gap-1">
                            <Container className="drow align-center gap-5p">
                                <BiPoll />
                                <label style={itemTipStyle}>{`${(formatNumber(score, 2))}%`}</label>
                            </Container>
                            {/* {newDisplaySize > 0 ? <Container className="drow align-center gap-5p">
                                <CalendarOutlined />
                                <label style={itemStyle}>{formatNumber(newDisplaySize)}</label>
                            </Container> : ""} */}
                        </Container>
                    </Container>}>
                        <div
                            style={{
                                position: "absolute",
                                left: (left - pLeft),
                                top: (top - pTop),
                                height,
                                width,
                                zIndex: 2,
                                cursor: "pointer",
                                color: "white",
                                overflow: "hidden"
                            }}
                            onClick={() => {
                                onClickTileComp(undefined, currentItem)
                            }}
                        >
                            <Container className="dcol fullscreen align-center justify-center" style={{ padding: "10px" }}>
                                <Container className="drow align-center gap-5p"><label style={{
                                    ...itemStyle,
                                    textAlign: "center"
                                }}>{currentItem.title || currentItem.name}</label></Container>
                                <Container className="drow align-center gap-1">
                                    <Container className="drow align-center gap-5p">
                                        <BiPoll style={{ fontSize: iconFontSize }} />
                                        <label style={itemStyle}>{`${(formatNumber(score, 2))}%`}</label>
                                    </Container>
                                    {/* {newDisplaySize > 0  ? <Container className="drow align-center gap-5p">
                                        <CalendarOutlined style={{ fontSize: "13px" }} />
                                        <label style={itemStyle}>{formatNumber(newDisplaySize)}</label>
                                    </Container> : ""} */}
                                </Container>
                            </Container>
                            {isLastComp ?
                                <BsInfoCircleFill
                                    onClick={() => { getBrandspaceSummaryTextComp(treeMapDataComp[idx]) }}
                                    style={{
                                        position: "absolute",
                                        // left: (left - pLeft) + (width - 20),
                                        // top: (top - pTop) + 5,
                                        right: "2px",
                                        top: "2px",
                                        color: "black",
                                        zIndex: 3,
                                        fill: "rgb(242 238 238)",
                                        fontSize: "15px",
                                        cursor: "pointer"
                                    }} /> : null}
                        </div></Tooltip>

                    tempList.push(divElem);
                })
                setInfoListComp(tempList)
            } catch (error) {
                setInfoListComp([])
            }
        }
    }

    const getColors = (list, isComp) => {
        if (!list.length) {
            if (isComp) {
                setTreeMapDataComp([])
            } else {
                setTreeMapData([])
            }
            return {
                list: [],
                newList: [],
                // negaList: []
            }
        }
        // const tempColors = getGradientColor(list.length)
        // const { positive, negative } = list.reduce((acc, item) => {
        //     const score = item.diff
        //     if (score > 0) {
        //         acc.positive += 1
        //     } else {
        //         acc.negative += 1
        //     }
        //     return acc
        // }, {
        //     negative: 0,
        //     positive: 0
        // })
        // const greenColors = positive ? [...generateTints("#458A46", positive, true)] : []
        // const redColors = negative ? [...generateTints("#B91C1C", negative)] : []

        // const tempColors = [...greenColors, ...redColors]
        // const negaList = []
        const newList = [...list].sort(dynamicSort("-segmentSize", true)).reduce((acc, item, idx) => {
            // if (!item.segmentSize || item.segmentSize < 0) {
            //     negaList.push({
            //         text: item.title || item.name,
            //         title: item.title || item.name,
            //         name: item.title || item.name,
            //         path: item.title || item.name,
            //         value: item.segmentSize,
            //         score: item.diff,
            //         segmentSize: item.segmentSize,
            //         diff: item.diff,
            //         tChildren: item.children,
            //         lvl: item.lvl,
            //     })
            // } else {
            acc.push({
                name: item.title || item.name,
                path: item.title || item.name,
                // value: item.masterSize,
                value: item.targetSize,
                // value: item.targetSize ? (((item.diff / 100) || 0) + 1) * Math.min(item.targetSize, item.masterSize) : item.segmentSize,
                score: item.diff,
                // color: tempColors[idx],
            })
            // }
            return acc
        }, []).sort(dynamicSort("-value", true))
        return {
            list: list.sort(dynamicSort("-targetSize", true)),
            newList
        }
    }

    const getTempList = (list) => {
        return [...list].sort(dynamicSort("-diff", true))
    }

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (breadItems.length > 1) {
                const currentBread = breadItems[breadItems.length - 1]
                if (currentBread.children) {
                    setSelectedItem(null)
                    dispatch(setReportIsLoading(true));

                    Promise.all(currentBread.children.map((dd) => {
                        return WhiteSpaceServices.getDeepDiveData(dd);
                    })).then((resp) => {
                        dispatch(setReportIsLoading(false))
                        const tempList = getTempList(resp)
                        const { list, newList } = getColors(tempList)
                        setTreeMapData(list);
                        setChartData(newList);
                        onload()
                    })
                }
            } else {
                const tempList = getTempList(generateGrid)
                const { list, newList } = getColors(tempList)
                setTreeMapData(list);
                setChartData(newList);
                onload()
                setSelectedItem(null)

                const { brands, mokbs, mokbsMicrosegments } = getBrandGenericsHcp()
                // let masterList = Object.keys(brands).length ? brands : mokbs
                if (Object.keys(brands).length) {
                    setTemporaryMokbMicroList({})
                    setBrandList(Object.values(Object.values(brands || {}).reduce((acc, arr) => {
                        arr.forEach((obj) => {
                            acc[obj.key] = {
                                label: obj.name,
                                value: obj.key
                            }
                        })
                        return acc
                    }, {})))
                } else {
                    setTemporaryMokbMicroList(mokbsMicrosegments)
                    setBrandList(Object.values(Object.values(mokbsMicrosegments || {}).reduce((acc, { key, name }) => {
                        acc[key] = {
                            label: name,
                            value: key
                        }
                        return acc
                    }, {})))
                }

            }

            setIsLast(breadItems.length === 3)
        }, 100)

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [generateGrid, breadItems])

    const competitorGetDiff = async (resp) => {
        let newResult = resp
        if (competitorCheckedCategories.length) {
            const checkedCompetitorBrands = competitorCheckedCategories.reduce((acc, brandName) => {
                if (temporaryMokbMicroList[brandName]) {
                    temporaryMokbMicroList[brandName].list.forEach(({ variant, key }) => {
                        acc.push(variant || key)
                    })
                } else acc.push(brandName)
                return acc
            }, [])

            const checkNumberIfValidNumber = (num, defaultNum = 0) => {
                if (num === Infinity) return defaultNum;
                if (isNaN(num)) return defaultNum;
                return num;
            };
            await WorkerServices.getWhiteSpaceCache([resp]).then((resultCache) => {
                const findInCache = (obj) => {
                    return resultCache.find((cacheObj) => cacheObj.path === obj.path)
                }
                newResult = resp.reduce((acc, item) => {
                    const found = findInCache(item);
                    if (found) {
                        const brandKeys = Object.keys(found).filter((key) => {
                            if (key.includes("_brands") && !key.includes("folder") && !key.includes("_ranked")) {
                                const brandName = key.split("_brands")[0].toLocaleLowerCase();
                                if (checkedCompetitorBrands.includes(brandName)) return key
                            }
                        })
                        const baseline_brandssave = checkNumberIfValidNumber(brandKeys.reduce((sum, key, idx) => {
                            // return sum += ((found.overallcount + 1) - (idx + 1)) / found.overallcount;
                            return sum += found[key]
                        }, 0) / brandKeys.length)
                        let baseline_diff = parseFloat((found.avegenerics - baseline_brandssave).toFixed(5));
                        baseline_diff = checkNumberIfValidNumber(baseline_diff * 100);

                        const newItem = {
                            ...item,
                            comp_genericsave: item.avegenerics,
                            comp_brandssave: item.avebrands,
                            comp_diff: item.diff,
                            baseline_genericsave: found.avegenerics,
                            baseline_brandssave,
                            baseline_diff,
                            diff: checkNumberIfValidNumber(item.diff - (baseline_brandssave * 100))
                            // diff: checkNumberIfValidNumber(baseline_diff - item.diff)
                        }
                        acc.push(newItem)
                    } else {
                        acc.push(item)
                    }
                    return acc
                }, [])
            })
        }

        return Promise.resolve(newResult)
    }
    useEffect(() => {
        let timeout = setTimeout(async () => {
            if (breadItemsComp.length > 1) {
                const currentBread = breadItemsComp[breadItemsComp.length - 1]
                if (currentBread.children) {
                    setSelectedItemComp(null)
                    setCompetitorLoading(true)
                    const newResp = (currentBread.children).map((obj) => WhiteSpaceServices.findItemInTree(obj))
                    WhiteSpaceServices.getWhiteSpaceCompetitors({
                        master: { [competitorMaster]: (temporaryMokbMicroList[competitorMaster]?.list || []).map(({ key, variant }) => variant || key) || [competitorMaster] },
                        categoriesArr: newResp,
                        categoriesList: newResp,
                        // masterName: competitorMaster + "~~~" + currentBread.title
                        masterName: competitorMaster
                    }).then(async (subres) => {
                        const prms = newResp.map((obj) => {
                            return WhiteSpaceServices.getDeepDiveData(obj).then((cached) => {
                                const objValue = subres[(obj.namePath || obj.path).toLocaleLowerCase()];
                                let score = 0;
                                let share = 0;
                                if (objValue?.count !== undefined) {
                                    score = objValue.sum / objValue.count
                                } else {
                                    score = objValue.score
                                }
                                share = objValue.share
                                return {
                                    ...cached,
                                    diff: score * 100,
                                    audienceIntersect: Math.min(share, obj.masterSize)
                                }
                            })
                        })

                        let newSubResp = await Promise.all(prms)
                        setCompetitorLoading(false)
                        newSubResp = await competitorGetDiff(newSubResp)
                        const tempList = getTempList(newSubResp)
                        const { list, newList } = getColors(tempList, true)
                        setTreeMapDataComp(list);
                        setChartDataComp(newList);
                        onloadComp()
                    })
                    // setSelectedItem(null)
                    // dispatch(setReportIsLoading(true));
                    // Promise.all(currentBread.children.map((dd) => {
                    //     return WhiteSpaceServices.getDeepDiveData(dd, true);
                    // })).then(async (resp) => {
                    //     dispatch(setReportIsLoading(false))
                    //     const newResp = await competitorGetDiff(resp)
                    //     const tempList = getTempList(newResp)
                    //     const { list, newList } = getColors(tempList, true)
                    //     setTreeMapDataComp(list);
                    //     setChartDataComp(newList);
                    //     onloadComp()
                    // })
                }
            } else {
                const newResp = await competitorGetDiff(competitorData)
                const tempList = getTempList(newResp)
                const { list, newList } = getColors(tempList, true)
                setTreeMapDataComp(list);
                setChartDataComp(newList);
                onloadComp()
                setSelectedItemComp(null)
            }

            setIsLastComp(breadItemsComp.length === 3)
        }, 100)

        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [competitorData, breadItemsComp, competitorCheckedCategories, temporaryMokbMicroList])

    useEffect(() => {
        const timeout = setTimeout(() => {
            setTriggerResize(collapseLSide);
        }, 700)
        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [collapseLSide])

    useEffect(() => {
        const timeout = setTimeout(() => {
            onload()
        }, 100)
        return () => {
            clearTimeout(timeout)
        }
    }, [mapRef, infoRef, treeMapData, isLast, triggerResize])

    const bodyRect = window.document.body.getBoundingClientRect()
    useEffect(() => {
        const timeout = setTimeout(() => {
            onloadComp()
        }, 100)
        return () => {
            clearTimeout(timeout)
        }
    }, [mapRefComp, infoRefComp, treeMapDataComp, isLastComp, triggerResize])

    useEffect(() => {
        let timeout = null
        function updateSize() {
            setInfoList([])
            if (timeout) {
                clearTimeout(timeout)
            }
            timeout = setTimeout(() => {
                onload()
                onloadComp()
                // onloadNega()
            }, 100)
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, [mapRef, infoRef, mapRefComp, infoRefComp, bodyRect.width, bodyRect.height]);

    const onChangeCompetitors = (values) => {
        setCompetitorCheckedCategories(values)
    }

    const onClickGenerateCompetitors = () => {
        if (competitorMaster) {
            setCompetitorLoading(true)
            WorkerServices.clearWhiteSpaceCompetitorCache([])
            debugger
            WhiteSpaceServices.getWhiteSpaceCompetitors({
                master: { [competitorMaster]: (temporaryMokbMicroList[competitorMaster]?.list || []).map(({ key, variant }) => variant || key) || [competitorMaster] },
                baseline: competitorCheckedCategories,
                // baseline: competitorCheckedCategories.reduce((acc, key) => {
                //     acc[key] = [key]
                //     return acc
                // }, {}),
                categories: generateGrid.map((obj) => obj.title),
                categoriesList: generateGrid,
                masterName: competitorMaster
            }, true).then(async (resp) => {
                const prms = generateGrid.map((obj) => {
                    return WhiteSpaceServices.getDeepDiveData(obj).then((cached) => {
                        const objValue = resp[(obj.namePath || obj.path).toLocaleLowerCase()];
                        let score = 0;
                        let share = 0;
                        if (objValue?.count !== undefined) {
                            score = objValue.sum / objValue.count
                        } else {
                            score = objValue.score
                        }
                        share = objValue.share
                        return {
                            ...cached,
                            diff: score * 100,
                            audienceIntersect: Math.min(share, obj.masterSize)
                        }
                    })
                })
                const newResp = await Promise.all(prms)
                setCompetitorData(newResp)
                const tempList = getTempList(newResp)
                const { list, newList } = getColors(tempList, true)
                setTreeMapDataComp(list);
                setChartDataComp(newList);
                onloadComp()
                // setCompetitorData(resp)
                // const tempList = getTempList(newResult)
                // const { list, newList } = getColors(tempList, true)
                // setTreeMapDataComp(list);
                // setChartDataComp(newList);
                // onloadComp()
                notification.destroy("reportsnotifComp");
                setCompetitorLoading(false)
            })
        }
    }
    useEffect(() => {
        if (generateWhitespaceReport && !reportIsLoading) {
            setBreadItems([{
                path: "summary",
                name: "Summary"
            }]);
            setBreadItemsComp([{
                path: "summary",
                name: "Summary"
            }]);
            dispatch(setGenerateWhitespaceReport(false));
            onClickGenerateCompetitors()
        }
    }, [generateWhitespaceReport, reportIsLoading, temporaryMokbMicroList])

    const onCheckAllChange = (e) => {
        setCheckAll(e.target.checked)

        if (e.target.checked) {
            setCompetitorCheckedCategories(brandList.map((obj) => obj.value))
        } else {
            setCompetitorCheckedCategories([])
        }
    }

    const onDownloadCompetitorCSV = () => {
        WhiteSpaceServices.getWhiteSpaceCompetitors({
            categoriesList: generateGrid,
            masterName: competitorMaster
        }).then(async (resp) => {
            return downloadWhitespaceCompetitor(competitorMaster, competitorCheckedCategories, resp)
        })
    }

    useEffect(() => {
        setCheckAll(competitorCheckedCategories.length === brandList.length)
    }, [brandList, competitorCheckedCategories])

    return (
        <Container className="report--newWhitespace">
            <div className="report--newWhitespace--header">
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Button
                            className="c-bg-400"
                            type="link"
                            style={{ padding: 0 }}
                            icon={<ArrowLeftOutlined />}
                            disabled={reportIsLoading}
                            onClick={() => {
                                dispatch(setGenerateGridData([]));
                            }}
                        >
                            Back
                        </Button>
                    </Breadcrumb.Item>
                    {breadItems.map((obj, idx) => {
                        if (breadItems.length - 1 === idx) {
                            return <Breadcrumb.Item key={obj.path}>
                                <span className="c-bg-700 fw-500 fs-16">
                                    {obj.title || obj.name}
                                </span>
                            </Breadcrumb.Item>
                        }
                        return <Breadcrumb.Item key={obj.path}>
                            <Button
                                disabled={reportIsLoading}
                                className="c-bg-400"
                                style={{ padding: 0 }}
                                type="link"
                                onClick={() => {
                                    setBreadItems((bread) => {
                                        return bread.filter((crum, i) => {
                                            if (i <= idx) return crum
                                        })
                                    })
                                }}
                            >
                                {obj.title || obj.name}
                            </Button>
                        </Breadcrumb.Item>
                    })}
                </Breadcrumb>
                <div className="d-flex gap-1">
                    {/* <Button
                    type="link"
                    onClick={() => {
                        // if (showVisualMode !== "grid") {
                        //     runLoadingCharts();
                        // }
                        // setShowVisualMode("charts");
                        // chartsBreadPushObj();
                    }}
                >
                    Advanced Analysis
                </Button> */}
                    {/* <Dropdown
                            disabled={disabledDownload || downloading}
                            menu={[]}
                        >
                            <Button
                                loading={disabledDownload || downloading}
                                disabled={disabledDownload || downloading}
                            >

                                {(disabledDownload || downloading)
                                    ? downloading ? "Downloading..." : "Preparing Charts..." : <>
                                        <DownloadOutlined style={{ marginRight: "2mm" }} />
                                        {"Download as"}
                                    </>}
                                <DownOutlined />
                            </Button>
                        </Dropdown> */}
                </div>
            </div>
            <Container className="report--newWhitespace--body">
                <Container className="drow gap-1 align-start" style={{ height: "100%", marginBottom: "3mm", minHeight: "611px" }}>
                    <Container className="report--newWhitespace--container"
                        style={{ width: selectedItem ? "calc(100% - 100mm)" : "100%" }}>
                        <Container className="dcol align-center">
                            <span style={{
                                fontSize: "18px",
                                fontWeight: 600,
                                padding: "2mm 4mm",
                                color: "#334155",
                                background: "#F1F5F9",
                                textAlign: "center",
                                width: "100%"
                            }}>WHITESPACES</span>
                        </Container>
                        <Container className="drow justify-end align-end">
                            <Container className="drow align-end gap-5p">
                                <Container className="drow align-center gap-5p">
                                    <BiPoll style={{ fontSize: "14px", color: "#2563EB" }} />
                                    <span style={{
                                        color: "#475569",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                        lineHeight: "16px"
                                    }}>Market Gap</span>
                                </Container>
                                <Container className="drow align-center gap-5p">
                                    <CalendarOutlined style={{ fontSize: "14px", color: "#2563EB" }} />
                                    <span style={{
                                        color: "#475569",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                        lineHeight: "16px"
                                    }}>Monthly Activity</span>
                                </Container>
                                <span style={{
                                    color: "#475569",
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    lineHeight: "16px"
                                }}>|</span>
                                <WhiteSpaceNewDisplayLegend />
                            </Container>
                        </Container>
                        <div style={{ height: "calc(100% - 37mm)", width: "100%" }}>
                            {!reportIsLoading ?
                                <>
                                    <div ref={infoRef} style={{ position: "relative" }}>
                                        {infoList.map((info) => info)}
                                    </div>
                                    <TreemapChart
                                        ref={mapRef}
                                        onload={onload}
                                        onClickTile={onClickTile}
                                        // customColor
                                        data={chartData}
                                        // width={chartDataNega.length ? "50%" : "100%"}
                                        config={{
                                            renderer: "svg",
                                            rawFields: ["value", "score"],
                                            label: {
                                                formatter: (e) => ""
                                            },
                                            tooltip: {
                                                formatter: (e) => ({ name: e.name, value: formatNumber(e.value) })
                                            },
                                            color: ({ score }) => {
                                                if (score > 40) return "#458A46"
                                                if (score > 10 && score <= 40) return "#57AD57"
                                                if (score > 5 && score <= 10) return "#7DC97F"
                                                if (score >= -5 && score <= 5) return "#88898B"
                                                if (score > -10 && score < -5) return "#EF4444"
                                                if (score > -40 && score <= -10) return "#DC2626"
                                                return "#B91C1C"
                                            }
                                        }}
                                    />
                                </>
                                : <TreeMapSkeleton />}
                        </div>
                        <Container>
                            <span style={{
                                // color: "#475569",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#64748B"
                            }}>*Size of each tile is proportionate to market size</span>
                        </Container>
                    </Container>
                    {selectedItem ? <WhiteSpaceNewDisplayDetails
                        style={{ width: "100mm", flex: 1, margin: 0, height: "100%" }}
                        selectedItem={selectedItem} list={text} loading={loadingText}
                    /> : null}
                </Container>

                {(!chartData.length) ? null : <>
                    <Container className="report--newWhitespace--container" style={{ height: "100%", marginBottom: "3mm", margin: 0, minHeight: "750px" }}>
                        <Container className="dcol gap-1">
                            <Container className="dcol align-center">
                                <span style={{
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    padding: "2mm 4mm",
                                    color: "#334155",
                                    background: "#F1F5F9",
                                    textAlign: "center",
                                    width: "100%"
                                }}>COMPETITOR ANALYSIS</span>
                            </Container>
                            <Container className="drow align-center justify-between gap-1">
                                <Container className="drow align-center gap-1">
                                    <span>Master: </span>
                                    {/* <CompetitorMaster config={{
                                    master: competitorMaster,
                                    setMaster: setCompetitorMaster,
                                    setIsError: setCompetitorIsError
                                }} /> */}
                                    <Select
                                        style={{
                                            minWidth: "50mm"
                                        }}
                                        showSearch
                                        placeholder="Select a person"
                                        optionFilterProp="children"
                                        onChange={(e) => {
                                            setCompetitorMaster(e)
                                        }}
                                        value={competitorMaster}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                        options={brandList}
                                    />
                                    <Button
                                        type="primary"
                                        disabled={competitorLoading || loadingTextComp}
                                        onClick={onClickGenerateCompetitors}>
                                        Analyze Competitor
                                    </Button>
                                </Container>
                                <Container className="drow align-center">
                                    <Button
                                        type="link"
                                        disabled={competitorLoading || loadingTextComp || !competitorData.length}
                                        onClick={onDownloadCompetitorCSV}
                                        icon={<DownloadOutlined />}
                                    >
                                        Download CSV
                                    </Button>
                                </Container>
                            </Container>
                            <Container className="dcol">
                                {/* <CheckboxGroup options={generateGrid.map((cat) => cat.title)} value={competitorCheckedCategories} onChange={onChangeCompetitors} /> */}

                                <Checkbox onChange={onCheckAllChange} checked={checkAll}>
                                    Check all
                                </Checkbox>
                                <CheckboxGroup options={brandList} value={competitorCheckedCategories} onChange={onChangeCompetitors} />
                            </Container>
                        </Container>
                        <Container>
                            {breadItemsComp.length > 1 ? <Breadcrumb>
                                {breadItemsComp.map((obj, idx) => {
                                    if (breadItemsComp.length - 1 === idx) {
                                        return <Breadcrumb.Item key={obj.path}>
                                            <span className="c-bg-700 fw-500 fs-16">
                                                {obj.title || obj.name}
                                            </span>
                                        </Breadcrumb.Item>
                                    }
                                    return <Breadcrumb.Item key={obj.path}>
                                        <Button
                                            disabled={reportIsLoading}
                                            className="c-bg-400"
                                            style={{ padding: 0 }}
                                            type="link"
                                            onClick={() => {
                                                setBreadItemsComp((bread) => {
                                                    return bread.filter((crum, i) => {
                                                        if (i <= idx) return crum
                                                    })
                                                })
                                            }}
                                        >
                                            {obj.title || obj.name}
                                        </Button>
                                    </Breadcrumb.Item>
                                })}
                            </Breadcrumb> : null}
                        </Container>
                        <Container className="drow justify-end align-end">
                            <Container className="drow align-end gap-5p">
                                <Container className="drow align-center gap-5p">
                                    <BiPoll style={{ fontSize: "14px", color: "#2563EB" }} />
                                    <span style={{
                                        color: "#475569",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                        lineHeight: "16px"
                                    }}>Percent Outperformance</span>
                                </Container>
                                {/* <Container className="drow align-center gap-5p">
                                    <CalendarOutlined style={{ fontSize: "14px", color: "#2563EB" }} />
                                    <span style={{
                                        color: "#475569",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                        lineHeight: "16px"
                                    }}>Monthly Activity</span>
                                </Container> */}
                                <span style={{
                                    color: "#475569",
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    lineHeight: "16px"
                                }}>|</span>
                                <WhiteSpaceNewDisplayLegend
                                    prefixLabel="Overperformance"
                                    midLabel=""
                                    suffixLabel="Underperformance"
                                    colors={["#3c7076", "#4c8e94", "#5cb2bb", "#88898B", "#fe726b", "#e34742", "#bc372f"]}
                                />
                            </Container>
                        </Container>
                        <div style={{ height: "calc(100% - 69mm)", width: "100%" }}>
                            {!competitorLoading ?
                                <>
                                    <div ref={infoRefComp} style={{ position: "relative" }}>
                                        {infoListComp.map((info) => info)}
                                    </div>
                                    <TreemapChart
                                        ref={mapRefComp}
                                        onload={onloadComp}
                                        // onClickTile={onClickTile}
                                        // customColor
                                        data={chartDataComp}
                                        config={{
                                            renderer: "svg",
                                            rawFields: ["value", "score"],
                                            label: {
                                                formatter: (e) => ""
                                            },
                                            tooltip: {
                                                formatter: (e) => ({ name: e.name, value: formatNumber(e.value) })
                                            },
                                            color: ({ score }) => {
                                                if (score > 40) return "#3c7076"
                                                if (score > 10 && score <= 40) return "#4c8e94"
                                                if (score > 5 && score <= 10) return "#5cb2bb"
                                                if (score >= -5 && score <= 5) return "#88898B"
                                                if (score > -10 && score < -5) return "#fe726b"
                                                if (score > -40 && score <= -10) return "#e34742"
                                                return "#bc372f"
                                            }
                                        }}
                                    />
                                </>
                                : <TreeMapSkeleton />}
                        </div>
                        <Container>
                            <span style={{
                                // color: "#475569",
                                fontSize: "12px",
                                fontWeight: "600",
                                lineHeight: "16px",
                                color: "#64748B"
                            }}>*Size of each tile is proportionate to market size</span>
                        </Container>

                    </Container>
                    {selectedItemComp ? <WhiteSpaceNewDisplayDetails
                        style={{ minHeight: "50mm", height: "auto", margin: 0, marginTop: "3mm" }}
                        selectedItem={selectedItemComp} text={textComp} loading={loadingTextComp}
                    /> : null}</>}

            </Container>
        </Container>
    );
}

export default WhiteSpaceNewDisplay;
